// BillingHeader.js
import { Button } from "react-bootstrap";

export default function BillingHeader() {
  return (
    <div className="billing-header">

      <div>
        <h3>Billing & Payments Dashboard</h3>
        <p>Overview of your billing, payments, and transactions.</p>
      </div>

      {/* <div className="actions">
        <Button variant="light">Need Help?</Button>
        <Button className="primary">Make a Payment</Button>
      </div> */}

    </div>
  );
}